export function styleString(styles: Record<string, string | number | undefined | null>): string {
  return Object.entries(styles)
    .filter(([, value]) => value !== undefined && value !== null && value !== '')
    .map(([key, value]) => `${key}:${value};`)
    .join('');
}

export function escapeHtml(value: string): string {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function mapHorizontalAlignment(value: any): string | undefined {
  switch (value) {
    case 'center':
      return 'center';
    case 'flex-end':
    case 'right':
      return 'right';
    case 'flex-start':
    case 'left':
      return 'left';
    default:
      return undefined;
  }
}

export function mapVerticalAlignment(value: any): string | undefined {
  switch (value) {
    case 'center':
      return 'middle';
    case 'end':
    case 'flex-end':
    case 'bottom':
      return 'bottom';
    case 'start':
    case 'flex-start':
    case 'top':
      return 'top';
    default:
      return undefined;
  }
}
